import React from "react";
import { array } from "prop-types";

import CustomStoryCard2 from "../../../molecules/CustomStoryCard2";

import "./organism1.m.css";

const Organism1 = ({ stories }) => {
  if (!(stories && stories.length)) {
    return null;
  }

  return (
    <div styleName="base">
      {stories.map((story, index) => (
        <CustomStoryCard2
          key={index}
          story={story}
          headlineType={27}
          subHeadlineType={6}
          isImageCaptionRequired={false}
          isSection={false}
          widths={global.deviceWidth < 876 ? [150] : [200]}
          isExcerpt={true}
          updatedFont={true}
          src="small-four-stories"
          updateSubHeadline={true}
        />
      ))}
    </div>
  );
};

Organism1.propTypes = {
  stories: array.isRequired,
};

export default Organism1;
